import { getApp, initializeApp } from 'firebase/app';
import { getFirestore,} from 'firebase/firestore';
import { getAuth } from "firebase/auth";
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
// Follow this pattern to import other Firebase services
// import { } from 'firebase/<service>';

const firebaseConfig = {
    apiKey: "AIzaSyCW5f2FRHNSEVrU5nEpL-efSs1DA3lnefQ",
  authDomain: "musculoskeletal-framework.firebaseapp.com",
  projectId: "musculoskeletal-framework",
  storageBucket: "musculoskeletal-framework.appspot.com",
  messagingSenderId: "815930818340",
  appId: "1:815930818340:web:5323d4ccb02637f0f67db1"
  
};

const app = initializeApp(firebaseConfig);
export  const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app)
const functions = getFunctions(getApp());
connectFunctionsEmulator(functions, "localhost", 5001);
